// import React from "react";
// import { TitleProps } from "@pankod/refine-core";
// import routerProvider from "@pankod/refine-react-router-v6";

import { Typography } from "@pankod/refine-antd";
import "./style.less";
import { BikeWhiteIcon } from "../../../components/icons";

type TitleProps = {
  collapsed: boolean;
};

const { Text } = Typography;

export const Title: React.FC<TitleProps> = ({ collapsed }) => {
  return (
    <div className="logo">
      {collapsed ? (
        <BikeWhiteIcon style={{ color: "white" }} />
      ) : (
        <img src="/images/creda-logo.png" alt="kks"  width={'200px'}/>
        // <Text strong>KKS or LOGO</Text>
      )}
    </div>
  );
};

// const { Link } = routerProvider;

// export const Title: React.FC<TitleProps> = ({ collapsed }) => (
//   <Link to="/">
//     {collapsed ? (
//       <img
//         src={"/refine-collapsed.svg"}
//         alt="Refine"
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           padding: "12px 24px",
//         }}
//       />
//     ) : (
//       <img
//         src={"/refine.svg"}
//         alt="Refine"
//         style={{
//           width: "200px",
//           padding: "12px 24px",
//         }}
//       />
//     )}
//   </Link>
// );
